import React from 'react'
import AppModal from '../common/AppModal'
import SendManualSmsForm from '../../forms/SendManualSmsForm'

interface SendManualSmsModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const SendManualSmsModal: React.FC<SendManualSmsModalProps> = ({
  open,
  onClose,
  loading,
  error
}) => {
  return (
    <AppModal open={open} onClose={onClose} title="Send Manual SMS" width="sm" loading={loading}>
      <SendManualSmsForm loading={loading} error={error} />
    </AppModal>
  )
}

export default SendManualSmsModal
